// extracted by mini-css-extract-plugin
export default {"root":"index2_root__Rsvaj","loading":"index2_loading__I+1dP","text":"index2_text__nx6lX","desc":"index2_desc__4HvZz"};